import type { CanvasCartPhoto } from 'types/photo_types';
import type { SavedArrangementCrop } from './saved_arrangements.types';
import { omit } from 'lodash';

const formatCropForSave = (crop: CanvasCartPhoto): SavedArrangementCrop => ({
  ...omit(crop.cartCrop, ['photo_url', 'original_filename', 'node_id']),
  canvas_id: crop.canvasId,
  node_uid: crop.nodeUid,
});

export default {
  formatCropForSave,
};
